import api from '@/lib/axios';
import {
  WriteProjectFileParams,
  ReadProjectFileParams,
  ProjectFileContent,
  ListProjectFilesParams,
  ProjectFileInfo,
} from '@/types/project';

/**
 * 项目文件模块 API
 * 封装项目文件的读写、列表查询等操作
 */
export const fileApi = {
  /**
   * 写入项目文件内容
   * @param data 写入参数
   */
  writeFile: (data: WriteProjectFileParams): Promise<boolean> => {
    return api.post('/lowcode-business/api/user/project-file/write', data);
  },

  /**
   * 读取项目文件内容
   * @param data 读取参数
   */
  readFile: (data: ReadProjectFileParams): Promise<ProjectFileContent> => {
    return api.post('/lowcode-business/api/user/project-file/read', data);
  },

  /**
   * 获取项目文件列表
   * @param data 查询参数
   */
  listFiles: (data: ListProjectFilesParams): Promise<ProjectFileInfo[]> => {
    return api.post('/lowcode-business/api/user/project-file/list', data);
  },
};
